import React from "react";

const HeaderBottom = () => {
  return (
    <>
      <section
        id="home"
        className="dtr-section dtr-section-with-bg dtr-hero-section-top-padding bg-blue"
        style={{
          backgroundImage:
            "url()",
          paddingTop: "135px",
        }}
      ></section>
    </>
  );
};

export default HeaderBottom;

